<template>
  <div>
  
    <SubHeader :text="$t('Calculated Attributes')" />
    <v-simple-table dense class="surfaces">
      <template v-slot:default>
        <!-- table header -->
        <thead>      
          <tr>
            <th scope="column"></th>
            <th :colspan="surfacesTbl.columns.length" scope="column">
              <SpecialAttributeList :items="items" :bundle="bundle" @attributeUpdated="updateAttribute($event)" />
            </th>
          </tr>
          <tr>
            <th :colspan="surfacesTbl.columns.length+1" scope="column" style="padding: 0">
              <SubHeader :text="$t('Other Attributes')" />
              <OtherAttributesList :items="items" :bundle="bundle"  />
    
            </th>
          </tr>
          <tr>
            <th :colspan="surfacesTbl.columns.length" style="padding: 0" scope="column">
              <SubHeader :text="$t('Surface Attributes')" />
            </th>
          </tr>
          <tr>
            <th scope="column"></th>
            <th class="text-center" v-for="(col, index) in surfacesTbl.columns" :key="index" scope="column">
              <lang :t="'SURFACES-ROW-' + col.val.toUpperCase()"></lang>
            </th>
          </tr>
        </thead>

        <!-- table body -->
        <tbody>
          <tr v-for="row in surfacesTbl.rows" :key="row.key">
            <td class="surfaces__image-td">
              <div class="surfaces__image-label">
                <img src="@/assets/img/cubes/cube-top.png" :alt="$t(row.key.toUpperCase())" v-if="row.key === 'top'" />
                <img src="@/assets/img/cubes/cube-bottom.png" v-else-if="row.key === 'bottom'" :alt="$t(row.key.toUpperCase())" />
                <img src="@/assets/img/cubes/cube-left.png" v-else-if="row.key === 'left'" :alt="$t(row.key.toUpperCase())" />
                <img src="@/assets/img/cubes/cube-right.png" v-else-if="row.key === 'right'" :alt="$t(row.key.toUpperCase())" />
                <img src="@/assets/img/cubes/cube-front.png" v-else-if="row.key === 'front'" :alt="$t(row.key.toUpperCase())" />
                <img src="@/assets/img/cubes/cube-rear.png" v-else-if="row.key === 'rear'" :alt="$t(row.key.toUpperCase())" />
              </div>
              <!-- <lang :t="row.key.toUpperCase()"></lang> -->
            </td>

            <td v-for="(col, index) in surfacesTbl.columns" :key="index">
              <div v-if="surfacesTbl.columns[index].children && surfacesTbl.columns[index].children.length > 0" class="surfaces__multiple-col">
                <div
                  @click="showSurfaceInfo(child.val, row.key)"
                  v-for="(child, childIndex) in surfacesTbl.columns[index].children"
                  :key="childIndex"
                >
                  <span class="surfaces__content-inline" v-if="!isBooleanValue(findSurfacesValue(child.val, row.key))">
                    <template v-if="child.val === 'pressure_area'">
                      {{ formatNumber(findSurfacesValue(child.val, row.key)) }}
                    </template>
                    <template v-else>
                      {{ findSurfacesValue(child.val, row.key) }}
                    </template>
                    <span class="surfaces__divider" v-if="childIndex < surfacesTbl.columns[index].children.length - 1">/</span>
                    <!-- <v-icon x-small>mdi-information-outline</v-icon> -->
                  </span>
                  <span class="surfaces__content-inline" v-else>
                    <div class="icon icon__complete" v-if="findSurfacesValue(surfacesTbl.columns[index].val, row.key) == 'true'"></div>
                    <div class="icon icon__incomplete" v-else></div>
                    <span class="surfaces__divider" v-if="childIndex < surfacesTbl.columns[index].children.length - 1">/</span>
                    <!-- <v-icon x-small>mdi-information-outline</v-icon> -->
                  </span>
                </div>
              </div>
              <div @click="showSurfaceInfo(surfacesTbl.columns[index].val, row.key)" v-else>
                <span class="surfaces__content" v-if="!isBooleanValue(findSurfacesValue(surfacesTbl.columns[index].val, row.key))">
                  <template v-if="surfacesTbl.columns[index].val === 'pressure_area'">
                    <span v-if="findSurfacesValue(surfacesTbl.columns[index].val, row.key) !== '-'">
                      {{ formatNumber(findSurfacesValue(surfacesTbl.columns[index].val, row.key)) }}
                    </span>
                    <span v-else>
                      {{ findSurfacesValue(surfacesTbl.columns[index].val, row.key) }}
                    </span>
                  </template>
                  <template v-else>
                    {{ findSurfacesValue(surfacesTbl.columns[index].val, row.key) }}
                  </template>
                  <!-- <v-icon x-small>mdi-information-outline</v-icon> -->
                </span>
                <span class="surfaces__content" v-else>
                  <div class="icon icon__complete" v-if="findSurfacesValue(surfacesTbl.columns[index].val, row.key) == 'true'"></div>
                  <div class="icon icon__incomplete" v-else></div>
                  <!-- <v-icon x-small>mdi-information-outline</v-icon> -->
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <Dialog :dialogSettings="dialog" :propBundle="bundle" :surfaceInfoResultSettings="surfaceInfoResult" @closeModal="closeModal" />
  </div>
</template>

<script>
import SubHeader from "@/components/ui-elements/SubHeader.vue";
import SpecialAttributeList from "./SpecialAttributeList.vue";
import OtherAttributesList from "./OtherAttributesList.vue";
import Dialog from "./Dialog.vue";
import { cloneDeep } from "lodash";
import { getNumberWith2Decimals } from "@/utilities/number";
export default {
  name: "SurfaceList",
  components: {
    SubHeader,
    SpecialAttributeList,
    OtherAttributesList,
    Dialog,
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    items: {
      handler() {
        this.surfacesData = this.bundle.surfaces ?? JSON.parse(this.bundle.surfaces);
      },
      deep: true,
    },
  },
  data() {
    return {
      dialog: {
        show: false,
        width: "640px",
        title: "",
        type: null,
        isLoading: false,
        isSaving: false,
        isPersistent: true,
      },
      surfacesTbl: {
        rows: [
          { key: "top", img: "cube-top.png" },
          { key: "bottom", img: "cube-bottom.png" },
          { key: "left", img: "cube-left.png" },
          { key: "right", img: "cube-right.png" },
          { key: "front", img: "cube-front.png" },
          { key: "rear", img: "cube-rear.png" },
        ],
        columns: [
          {
            label: "Nature",
            val: "nature",
          },
          {
            label: "Relief",
            val: "relief",
          },
          {
            label: "Type",
            val: "type",
          },
          {
            label: "Material",
            val: "material",
          },
          {
            label: "Material Area",
            val: "material_area",
          },
          {
            label: "Pressure Area",
            val: "pressure_area",
          },
          {
            label: "Top Orientable",
            val: "top_orientable",
          },
          {
            label: "Material H/W/L Bars",
            val: "material_h_w_l_bars",
            children: [
              {
                label: "Material Height Bars",
                val: "material_height_bars",
              },
              {
                label: "Material Width Bars",
                val: "material_width_bars",
              },
              {
                label: "Material Length Bars",
                val: "material_length_bars",
              },
            ],
          },
          {
            label: "Dimensions H/W/L Bars",
            val: "dimensions_h_w_l_bars",
            children: [
              {
                label: "Dimensions Height Bars",
                val: "dimension_height_bars",
              },
              {
                label: "Dimensions Width Bars",
                val: "dimension_width_bars",
              },
              {
                label: "Dimensions Length Bars",
                val: "dimension_length_bars",
              },
            ],
          },
          {
            label: "Pressure H/W/L Bars",
            val: "pressure_h_w_l_bars",
            children: [
              {
                label: "Pressure Height Bars",
                val: "pressure_height_bars",
              },
              {
                label: "Pressure Width Bars",
                val: "pressure_width_bars",
              },
              {
                label: "Pressure Length Bars",
                val: "pressure_length_bars",
              },
            ],
          },
          {
            label: "Elasticity",
            val: "elasticity",
          },
        ],
      },
      surfacesData: {},
      surfaceInfoResult: null,
      editItem: null,
    };
  },
  computed: {
    isBooleanValue() {
      return (value) => {
        return ["true", "false"].includes(value) || typeof value == "boolean";
      };
    },
    formatNumber() {
      return (number) => {
        return getNumberWith2Decimals(number);
      };
    },
  },
  created() {
    this.surfacesData = cloneDeep(this.bundle.surfaces);
  },
  methods: {
    updateAttribute(editedItem) {
      this.$emit("attributeUpdated", editedItem);
    },
    showSurfaceInfo(val, rowKey) {
      let payload = {
        bundleId: this.bundle.id,
        name: "SURFACE." + val.toUpperCase(),
        side: rowKey.toUpperCase(),
      };

      this.dialog = Object.assign(this.dialog, {
        type: "surfaceInfo",
        width: "96%",
        show: true,
        isLoading: true,
      });
      // const getRules = () => this.$axios.get('calculationrules');
      const getRuleSettings = () => this.$axios.get("calculationrules/settings");
      const getConstants = () => this.$axios.get("constants");

      this.surfaceInfoResult = {
        settings: null,
        constants: null,
        result: null,
        isLoading: true,
      };

      Promise.all([getRuleSettings(), getConstants()])
        .then(([settings, constants]) => {
          // this.testing.rules = rules.data;
          this.surfaceInfoResult.settings = settings.data;
          this.surfaceInfoResult.constants = constants.data;

          this.axios.post(this.$config.api + "/calculationrules/testByName", payload).then((res) => {
            this.surfaceInfoResult.result = res.data;
            this.surfaceInfoResult.isLoading = false;
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    findSurfacesValue(val, rowKey) {
      if (!this.surfacesData || this.surfacesData == null || this.surfacesData.length == 0) {
        return "-";
      }

      let res = null;

      this.surfacesData.every((surface) => {
        if (surface[rowKey]) {
          res = surface[val];
          return false;
        }
        return true;
      });

      return res == null
        ? "-"
        : String(res)
            .replace(/_/g, " ")
            .toLowerCase();
    },
    closeModal(dialog) {
      this.dialog = cloneDeep(dialog);

      this.surfaceInfoResult = null;
      this.editItem = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.surfaces {
  & table {
    overflow: auto;
  }
  & td {
    min-width: 30px !important;
    height: 45px !important;
    text-align: center;
    vertical-align: middle;
    position: relative;
    font-size: 14px !important;
    padding: 0 14px !important;
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-inline {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__divider {
    padding: 0 0.1em;
  }

  &__multiple-col {
    display: flex;
    justify-content: center;
    align-items: center;
    & > * {
      display: inline;
    }
  }

  &__image-td {
    width: 35px !important;
    min-width: 20px !important;
    overflow: hidden;
  }

  &__image-label {
    width: 30px !important;
    height: 30px !important;
    position: relative;
    display: block;
    & > img {
      width: 100%;
      height: auto;
      filter: invert(41%) sepia(83%) saturate(2218%) hue-rotate(156deg) brightness(84%) contrast(79%);
    }
  }
  table td {
    min-width: 120px;
  }
  table td:not(:first-child) {
    text-align: left;

    &:hover{
      color: black;
    }

    i.v-icon {
      // position: absolute;
      // bottom: 0;
      // right: 0;
      // z-index: 10;
      float: none;
      display: block;
      visibility: hidden;
    }

    &:hover {
      //.value { display: none; }
      i.v-icon {
        visibility: visible;
      }
    }
  }
}
</style>
